<template>
  <div
    :class="aiCanvasRobot ? 'ai-chat-container' : 'ai-chat-otherpage-container'"
  >
    <div
      v-loading="isLoadingHistory"
      :element-loading-text="$t('aiChat.loadingHistory')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      style="height: 100%; position: relative"
    >
      <!-- 添加自定义房间名称标题，带有tooltip -->
      <div class="custom-room-header" v-if="aiCanvasRobot">
        <el-tooltip
          :content="rooms[0].originalRoomName || rooms[0].roomName"
          placement="top"
          effect="light"
        >
          <div class="room-name">{{ rooms[0].roomName }}</div>
        </el-tooltip>
      </div>
      <div v-else class="custom-room-header">
        <aicanvasIcons name="bigRobotIcon" />
        <div class="room_info">
          <el-tooltip
            :content="rooms[0].originalRoomName || rooms[0].roomName"
            placement="top"
            effect="light"
          >
            <div class="room-name">{{ rooms[0].roomName }}</div>
          </el-tooltip>
          <p>{{ $t("aiChat.welcomeConsult") }}</p>
        </div>
      </div>

      <vue-advanced-chat
        :current-user-id="currentUserId"
        :rooms="rooms"
        :messages="messages"
        :rooms-loaded="true"
        :messages-loaded="true"
        height="100%"
        :show-search="false"
        :show-add-room="false"
        :show-send-icon="true"
        :show-files="false"
        :show-audio="false"
        :show-emojis="false"
        :show-reaction-emojis="false"
        :show-new-messages-divider="false"
        :text-messages="textMessages"
        :theme="'light'"
        :styles="chatStyles"
        :loading="isStreaming"
        :single-room="true"
        :message-content-render-html="true"
        :check-updates="false"
        :message-actions="[]"
        :message-selection-actions="[]"
        :menu-actions="[]"
        :database-config="{ disabled: true }"
        @send-message="onMessageWasSent"
      />
    </div>
    <!-- 自定义发送按钮组件 -->
    <div
      class="custom-send-button"
      :class="{
        active: hasInputContent && !isStreaming,
        stop: isStreaming && !isloading,
        loading: isStreaming && isloading,
      }"
      @click="
        isloading ? null : isStreaming ? stopGeneration() : triggerSendMessage()
      "
    >
      <aicanvasIcons
        v-if="!isStreaming"
        name="analysis-btn-icon"
        class="send-icon"
      />
      <aicanvasIcons v-else-if="isStreaming && isloading" name="loadingIcon" />
      <aicanvasIcons v-else name="stopIcon" class="stop-icon" />
    </div>
    <!-- 反馈弹窗 -->
    <FeedbackDialog
      :visible="feedbackModalVisible"
      :feedback-reasons="feedbackReasons"
      :feedback-form="feedbackForm"
      :feedback-file-list="feedbackFileList"
      :feedback-uploading="feedbackUploading"
      :feedback-preview-image="feedbackPreviewImage"
      :preview-visible.sync="feedbackUploadPreviewVisible"
      :oss-upload-request="handleFeedbackOssUpload"
      :on-toggle-reason="toggleFeedbackReason"
      :on-close="closeFeedbackModal"
      :on-confirm="confirmFeedback"
      :on-upload-change="handleUploadChange"
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview"
    />

    <!-- 底部工具栏 -->
    <!-- <div class="chat-tools">
      <div
        class="tool-button"
        :class="{ active: knowledgeEnabled }"
        @click="handleKnowledgeBase"
      >
        <aicanvasIcons name="knowledgeIcon" />
        <span>图链知识库</span>
      </div>
      <div
        class="tool-button"
        :class="{ active: !knowledgeEnabled }"
        @click="handleAddressAnalysis"
      >
        <aicanvasIcons name="assessmentIcon" />
        <span>地址研判分析</span>
      </div>
    <div
        class="tool-button"
        style="border-radius: 50%; padding: 6px"
        @click="historicalRecords"
      >
        <el-tooltip content="对话记录" placement="top" effect="light">
          <span>
            <aicanvasIcons name="historicalIcon" />
          </span>
        </el-tooltip>
      </div> 
    </div> -->
  </div>
</template>

<script>
import VueAdvancedChat from "vue-advanced-chat";
import "vue-advanced-chat/dist/vue-advanced-chat.css";
import "highlight.js/styles/github.css";
import "github-markdown-css/github-markdown.css";

// Mixins
import ChatCoreMixin from "@/utils/AICanvasMixins/ChatCoreMixin.js";
import EventSourceMixin from "@/utils/AICanvasMixins/EventSourceMixin.js";
import MarkdownMixin from "@/utils/AICanvasMixins/MarkdownMixin.js";
import MessageActionsMixin from "@/utils/AICanvasMixins/MessageActionsMixin.js";
import AnalysisProcess from "@/utils/AICanvasMixins/AnalysisProcess.js";
import FeedbackMixin from "@/utils/AICanvasMixins/FeedbackMixin.js";
import FeedbackOssMixin from "@/utils/AICanvasMixins/FeedbackOssMixin.js";

// Components
import aicanvasIcons from "@/components/icons/aiIcons.vue";
import FeedbackDialog from "@/components/AIcanvas/FeedbackDialog.vue";

export default {
  name: "AIChat",
  components: {
    "vue-advanced-chat": VueAdvancedChat,
    aicanvasIcons,
    FeedbackDialog,
  },
  mixins: [
    ChatCoreMixin,
    EventSourceMixin,
    MarkdownMixin,
    MessageActionsMixin,
    AnalysisProcess,
    FeedbackMixin,
    FeedbackOssMixin,
  ],
  props: {
    onGraphData: {
      type: Function,
      default: null,
    },
    messageList: {
      type: Array,
      default: () => [],
    },
    aiCanvasRobot: {
      type: Boolean,
      default: false,
    },
    ai_Model_Types: {
      type: String,
      default: "ADDRESS_ANALYSIS",
    },
  },
  watch: {
    messageList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.updataMessageList(newVal);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/AIcanvas/ai_customize_style.less";
</style>

<style lang="less">
@import "@/assets/css/AIcanvas/ai_component_style.less";
@import "@/assets/css/AIcanvas/ai_analysis_process.less";
@import "@/assets/css/AIcanvas/ai_canvas_feedback.less";
pre {
  white-space: pre-wrap !important;
  word-break: break-word !important;
}
code {
  white-space: pre-wrap !important;
  word-break: break-word;
}

/* Hide scrollbar for vac-container-scroll */
.vac-container-scroll::-webkit-scrollbar {
  display: none;
}

.vac-container-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-top: 50px !important;
}

/* 隐藏vue-advanced-chat默认的房间标题 */
.vac-room-header {
  display: none !important;
}
</style>
